// extracted by mini-css-extract-plugin
export default {"wrapper":"ResponsiveLoader_wrapper__i8fkU"};